var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],class:[
    _vm.value
      ? 'fas fa-check-circle text-success'
      : 'fas fa-times-circle text-danger' ]})}
var staticRenderFns = []

export { render, staticRenderFns }